import { ESpecProjectType } from '../types/developer/specProject';

export function isFsk(specProjectType?: ESpecProjectType | null) {
  if (!specProjectType) {
    return false;
  }

  return specProjectType === ESpecProjectType.Fsk;
}
